var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import PlaceholderSvg from './placeholder.icon.svg';
export const PlaceholderIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: PlaceholderSvg }));
_react_refresh_temp_1 = PlaceholderIcon;
$RefreshReg$(_react_refresh_temp_1, "PlaceholderIcon");
